import styled, { css, keyframes } from 'styled-components';
import Button from '@material-ui/core/Button';

const pulse2 = keyframes`
    to {
      box-shadow: 0 0 0 10px rgba(232, 76, 61, 0);
    }
`;

export const Attribution = styled.div`
    position: fixed;
    top: 20px;
    left: 140px;
    background: rgba(255,255,255,0.6);
    z-index: 99;
    padding: 2px 5px;
    font-size: 10px;
    a:hover {
      text-decoration: underline;
    }
`;

export const FBLIke = styled.div`
  position: fixed;
  bottom: 70px;
  left: 50%;
  transform: translate(-50%, 0);
`;

export const HelpButton = styled(Button)`
  && {
    border: none;
    position: fixed;
    left: 50%;
    top: 30px;
    background: green;
    color: #fff;
    display: inline-block;
    padding: 6px 12px;
    font-size: 12px;
    border-radius: 3px;
    transform: translate(-50%, 10px);
    text-decoration: none !important;
    box-shadow: 0 0 0 0 green;
    -webkit-animation: ${pulse2} 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
    -moz-animation: ${pulse2} 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
    -ms-animation: ${pulse2} 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
    animation: ${pulse2} 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
    i {
      font-size: 16px;
      vertical-align: middle;
      position: relative;
      top: -3px;
    }
    &:active,
    &:visited {
      background: green;
      color: #fff;
    }
    &:hover {
      color: green;
      background: #fff;
      text-decoration: none;
    }
  }
`;

export const MapWrapper = styled.div`
  z-index: 999;
  background: #fff;
  pointer-events: all;
`;

export const Statuses = styled.div`
  position: absolute;
  top: 23px;
  left: 10px;
  width: 120px;
`;

export const StatusItem = styled.div`
  width: 15px;
  justify-content: center;
  align-items: center;
  color: #fff;
  display: inline-flex;
  background: #000;
  border-radius: 50%;
  height: 15px;
  margin: 1px;
  font-size: 10px;
  ${props =>
    props.visibility.active &&
    css`
      color: #74ff74;
    `}
  ${props =>
    props.visibility.inactive &&
    css`
      color: #ff0000;
    `}
`;
